var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { QueryClient } from 'react-query';
import { persistQueryClient } from 'react-query/persistQueryClient-experimental';
import config from './config';
import Debug from '../util/Debug';
import StoragePersistor from './StoragePersistor';
export default class AtoZQueryClient {
    static configure() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!AtoZQueryClient.instance) {
                AtoZQueryClient.instance = new AtoZQueryClient();
            }
            else {
                return;
            }
            AtoZQueryClient.queryClient = new QueryClient({
                defaultOptions: {
                    queries: {
                        cacheTime: config.ReactQuery.QUERY_CACHE_TIME,
                    },
                },
            });
            yield persistQueryClient({
                queryClient: AtoZQueryClient.queryClient,
                persistor: StoragePersistor,
                maxAge: config.ReactQuery.PERSIST_CACHE_MAX_AGE,
            });
        });
    }
    static getQueryClient() {
        if (!AtoZQueryClient.queryClient) {
            Debug.error('AtoZQueryClient is not initialized yet!');
        }
        return AtoZQueryClient.queryClient;
    }
    static clearQueryClient() {
        var _a;
        (_a = this.getQueryClient()) === null || _a === void 0 ? void 0 : _a.clear();
    }
}
//# sourceMappingURL=AtoZQueryClient.js.map